import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getROPicklistCreate = get('reservation.routes.ROPicklist.create');

export const getIsSaving = createSelector(getROPicklistCreate, get('saving'));

export const getIsSaved = createSelector(getROPicklistCreate, get('saved'));
